<template>
  <v-layout justify-center>
    <!-- loaging -->
    <v-overlay :value="overlay">
      <img
        :src="require('@/Arquivos/onload.gif')"
        style="width: 70px; height: 70px"
      />
    </v-overlay>
    <!-- loaging -->

    <!-- MENSAGEM -->
    <v-snackbar elevation="13" v-model="alert">
      {{ msgAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="fecharAlert()">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <!-- MENSAGEM -->

    <!-- botão add -->
    <!-- <v-btn
        block
        x-large
        elevation="24"
        color="blue"
        @click="
          limpaCampos();
          objSlide = 2;
        "
      >
        <v-icon>mdi-checkbox-marked-outline</v-icon>Nova Indicação
      </v-btn> -->
    <!-- DIALOG e Lista de Solicitações Add INICIO-->

    <v-stepper align="center" v-model="objSlide">
      <v-alert dense class="text-center" color="#2196f3">
        <strong style="color: white">Demanda</strong>
        <v-fab-transition>
          <v-btn
            color="#feca26"
            fab
            dark
            absolute
            bottom
            left
            v-if="objSlide == 1"
            @click="
              limpaCampos();
              objSlide = 2;
            "
          >
            <v-icon large color="black"> mdi-plus-box</v-icon>
          </v-btn>
        </v-fab-transition>
        <v-fab-transition>
          <v-btn
            color="#feca26"
            fab
            dark
            absolute
            bottom
            left
            v-if="objSlide != 1"
            @click="objSlide = 1"
          >
            <v-icon large color="black">mdi-reply</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-alert>

      <!-- lista geral demanda -->
      <v-stepper-content step="1" max-width="300px">
        <v-img
          v-if="!solicitacoes.length"
          :src="require('@/Arquivos/dicasIndicacaoMobile.png')"
          max-width="500px"
        ></v-img>

        <template v-for="(item, i) in solicitacoes">
          <v-col :key="i" cols="12" sm="6" md="6">
            <!--CARD-->
            <v-card
              @click="
                EditarDemanda(item);
                objSlide = item.status == 'FECHADO' ? 5 : 4;
              "
              :elevation="5"
              height="250px"
              color="#2196f3"
            >
              <v-img
                :src="item.img"
                height="200px"
                :style="
                  item.status == 'FECHADO' ? 'opacity: 0.8' : 'opacity: 1'
                "
              >
                <v-fab-transition>
                  <v-btn color="#000000ba" small title="Em Andamento">
                    <v-icon color="white" v-if="item.status == 'ABERTO'"
                      >mdi-email-outline</v-icon
                    >
                    <label style="color: white" v-if="item.status == 'ABERTO'"
                      >- Enviado</label
                    >

                    <v-icon color="#feca26" v-if="item.status == 'ANALISE'"
                      >mdi-file-find</v-icon
                    >
                    <label
                      style="color: #feca26"
                      v-if="item.status == 'ANALISE'"
                      >- Análise</label
                    >

                    <v-icon color="#2196f3" v-if="item.status == 'FECHADO'"
                      >mdi-file-find</v-icon
                    >
                    <label
                      style="color: #2196f3"
                      v-if="item.status == 'FECHADO'"
                      >- Resolvido</label
                    >
                  </v-btn>
                </v-fab-transition>
              </v-img>

              <v-card-subtitle>
                <v-row class="flex-column">
                  <p style="color: white" class="text-center">
                    <b>{{ item.assunto }}</b>
                  </p>
                </v-row>
              </v-card-subtitle>
            </v-card>
            <!--CARD-->
          </v-col>
        </template>
      </v-stepper-content>
      <!-- lista geral -->

      <!-- lista Modalidades icones -->
      <v-stepper-content step="2">
        <v-col cols="12" sm="12" md="12">
          <v-row>
            <template v-for="(item, i) in modalidades">
              <v-col :key="i" cols="6" sm="6" md="3">
                <v-hover>
                  <template v-slot="{ hover }">
                    <v-card
                      :elevation="hover ? 14 : 6"
                      class="mx-auto"
                      max-width="150px"
                    >
                      <v-img
                        :src="require('@/Arquivos/icons/' + item.nome + '.png')"
                        @click="
                          objSlide = 3;
                          demanda.modalidade = item.nome;
                        "
                      ></v-img>
                    </v-card>
                  </template>
                </v-hover>
              </v-col>
            </template>
          </v-row>
        </v-col>
        <v-btn
          color="warning"
          @click="
            limpaCampos();
            objSlide = 1;
          "
          class="ma-2"
          large
        >
          <v-icon>mdi-keyboard-return</v-icon>
        </v-btn>
      </v-stepper-content>
      <!-- lista Modalidades -->

      <!-- Cadastro Demanda -->
      <v-stepper-content step="3">
        <!-- IMAGEM -->

        <v-col cols="12" sm="12" md="12">
          <div
            class="base-image-input"
            :style="{ 'background-image': `url(${arquivo})` }"
            @click="abrirSelecaoImagem()"
          >
            <span
              v-if="!arquivo"
              class="placeholder"
              align="center"
              height="150"
              width="70"
            >
              <img
                :src="require('@/Arquivos/imagemClick.gif')"
                style="width: 180px; height: 180px"
              />
            </span>
            <input
              class="file-input"
              ref="fileInput"
              type="file"
              @input="quandoSelecionarImagem"
            />
          </div>
        </v-col>

        <!-- IMAGEM -->
        <br />
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            background-color="#2196f3"
            filled
            dark
            disabled
            label="Modalidade"
            v-model="demanda.modalidade"
          />
          <v-text-field
            background-color="#e0e0e090 lighten-4"
            filled
            auto-grow
            label="Assunto"
            class="purple-input"
            required
            :rules="assuntoRules"
            v-model="demanda.assunto"
          />

          <v-textarea
            background-color="#e0e0e090 lighten-4"
            no-resize
            rows="3"
            filled
            label="Descrição"
            required
            :rules="descricaoRules"
            v-model="demanda.descricao"
          />

          <!-- MAPS -->
          <v-card
            class="mt-4 mx-auto"
            elevation="9"
            width="710px"
            color="#2196f3"
          >
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="cyan"
              max-width="calc(100% - 32px)"
            >
              <gmap-map
                :center="center"
                :zoom="13"
                style="width: 680x; height: 350px"
              >
                <gmap-marker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  @click="center = m.position"
                ></gmap-marker>
              </gmap-map>
            </v-sheet>

            <v-card color="#e0e0e090" style="width: 98%; height: 50px">
              <!-- CAMPO TEXTO -->
              <gmap-autocomplete
                style="width: 98%; height: 50px; font-size: 16px"
                @place_changed="setPlace"
                :value="''"
                :options="{
                  fields: [
                    'geometry',
                    'formatted_address',
                    'address_components',
                  ],
                }"
                :placeholder="'  Pesquise sua localização ...'"
              />
              <!-- CAMPO TEXTO -->
            </v-card>
            <!-- <br>
              <v-btn @click="setPlace()">Localização Atual</v-btn> -->
            <v-alert
              dense
              color="#2196f3"
              dark
              icon="mdi-map-marker-radius-outline"
            >
              {{ EnderecoPersonalizado }}
            </v-alert>
          </v-card>
          <!-- MAPS -->

          <v-col cols="12" sm="12" md="12">
            <v-btn
              :loading="btnDisabled"
              @click="validaSalvarEditar(demanda.id)"
              color="success"
              class="ma-2"
              x-large
            >
              <v-icon>mdi-checkbox-marked-outline</v-icon>
            </v-btn>
          </v-col>
        </v-form>
      </v-stepper-content>
      <!-- Cadastro Demanda -->

      <!-- Visualização Demanda com timeline-->
      <v-stepper-content step="4">
        <!-- btn andamento e formulario -->
        <v-col cols="12" sm="12" md="12">
          <v-row>
            <v-col cols="3" sm="3" md="3"> </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-fab-transition>
                <v-hover>
                  <v-card
                    v-if="objSlide2 == 2"
                    step="1"
                    @click="objSlide2 = 1"
                    shaped
                    elevation="3"
                  >
                    <br />
                    <img
                      :src="require('@/Arquivos/icons/form.png')"
                      style="width: 55px; height: 55px"
                    /><br />
                    <label style="color: #2196f3"
                      ><strong>Ver Formulário</strong></label
                    >
                  </v-card>
                </v-hover>
              </v-fab-transition>
              <v-fab-transition>
                <v-hover>
                  <v-card
                    v-if="objSlide2 == 1"
                    step="2"
                    @click="objSlide2 = 2"
                    elevation="3"
                    shaped
                  >
                    <br />
                    <img
                      :src="require('@/Arquivos/icons/timeline.png')"
                      style="width: 55px; height: 55px"
                    /><br />
                    <label style="color: #2196f3"
                      ><strong>Ver Andamento</strong></label
                    >
                  </v-card>
                </v-hover>
              </v-fab-transition>
            </v-col>
            <v-col cols="3" sm="3" md="3"> </v-col>
          </v-row>
        </v-col>
        <!-- btn andamento e formulario -->

        <!-- formulario -->
        <div v-if="objSlide2 == 1">
          <!-- IMAGEM -->

          <v-col cols="12" sm="12" md="12">
            <div
              class="base-image-input"
              :style="{ 'background-image': `url(${arquivo})` }"
            >
              <span
                v-if="!arquivo"
                class="placeholder"
                align="center"
                height="150"
                width="70"
              >
                <img
                  :src="require('@/Arquivos/imagemClick.gif')"
                  style="width: 180px; height: 180px"
                />
              </span>
              <input
                class="file-input"
                ref="fileInput"
                type="file"
                @input="quandoSelecionarImagem"
              />
            </div>
          </v-col>

          <!-- IMAGEM -->
          <br />
          <v-text-field
            background-color="#2196f3"
            filled
            dark
            disabled
            label="Protocolo"
            v-model="demanda.protocolo"
          />
          <v-text-field
            background-color="#2196f3"
            filled
            dark
            disabled
            label="Modalidade"
            v-model="demanda.modalidade"
          />
          <v-text-field
            background-color="#2196f3"
            filled
            dark
            disabled
            label="Assunto"
            v-model="demanda.assunto"
          />

          <v-textarea
            background-color="#2196f3"
            color="white !important"
            no-resize
            type="info"
            dark
            rows="3"
            filled
            disabled
            label="Descrição"
            required
            v-model="demanda.descricao"
          />

          <!-- MAPS -->
          <v-card
            class="mt-4 mx-auto"
            elevation="9"
            width="710px"
            color="#2196f3"
          >
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="#2196f3"
              max-width="calc(100% - 32px)"
            >
              <gmap-map
                :center="center"
                :zoom="13"
                style="width: 680x; height: 350px"
              >
                <gmap-marker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  @click="center = m.position"
                ></gmap-marker>
              </gmap-map>
            </v-sheet>

            <v-alert
              dense
              color="#2196f3"
              type="info"
              icon="mdi-map-marker-radius-outline"
            >
              {{ EnderecoPersonalizado }}
            </v-alert>
          </v-card>
          <!-- MAPS -->
          <v-divider></v-divider>
        </div>
        <!-- formulario -->

        <!-- andamento -->
        <div v-if="objSlide2 == 2">
          <v-timeline align-top dense>
            <v-slide-x-reverse-transition group hide-on-leave>
              <v-timeline-item
                class="justify-left"
                v-for="(card, index) in demanda.andamento"
                :key="index"
                :item="card"
                small
                fill-dot
                :color="card.color"
                left
                font-weight-light
              >
                <v-alert :value="true" :color="card.color">
                  <div style="width: 170px">
                    <strong>{{ card.titulo }}</strong>
                  </div>
                  <br />

                  <div
                    class="d-flex justify-space-between caption"
                    style="width: 170px"
                  >
                    {{ card.descricao }}
                  </div>

                  <br />
                  <div
                    class="d-flex justify-center caption"
                    style="width: 170px"
                  >
                    {{ dataFormatada(card.dataEnvio) }}
                  </div>
                  <!-- <div
                      class="d-flex justify-center caption"
                      style="width: 170px"
                    >
                      {{ card.remetente }}
                    </div> -->
                </v-alert>
              </v-timeline-item>
            </v-slide-x-reverse-transition>
          </v-timeline>
          <v-divider></v-divider>

          <!-- TEXTO MSG -->
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="texto"
                  outlined
                  clearable
                  label="mensagem"
                  type="text"
                >
                  <template v-slot:prepend>
                    <v-icon color="#feca26"> mdi-email </v-icon>
                  </template>
                  <template v-slot:append-outer>
                    <v-fade-transition leave-absolute>
                      <v-progress-circular
                        v-if="carregando"
                        size="24"
                        color="info"
                        indeterminate
                      ></v-progress-circular>
                      <v-icon
                        v-else
                        @click="salvarTextoMensagem"
                        color="info"
                        alt=""
                        >mdi-send</v-icon
                      >
                    </v-fade-transition>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <!-- TEXTO MSG -->

          <v-divider></v-divider>
        </div>
        <!-- andamento -->
      </v-stepper-content>
      <!-- Visualização -->

      <!-- Visualização Após Fechamento-->
      <v-stepper-content step="5">
        <div>
          <strong style="color: #2196f3">SOLUÇÃO FINAL</strong>
          <v-textarea
            background-color="#2196f3"
            color="white !important"
            no-resize
            type="info"
            dark
            rows="12"
            filled
            disabled
            required
            v-model="demanda.solucaoDemanda"
          />
          <!-- IMAGEM  pos fechar-->
          <v-col cols="12" sm="12" md="12">
            <div
              class="base-image-input"
              :style="{ 'background-image': `url(${arquivo})` }"
            >
              <span
                v-if="!arquivo"
                class="placeholder"
                align="center"
                height="150"
                width="70"
              >
                <img
                  :src="require('@/Arquivos/imagemClick.gif')"
                  style="width: 180px; height: 180px"
                />
              </span>
              <input
                class="file-input"
                ref="fileInput"
                type="file"
                @input="quandoSelecionarImagem"
              />
            </div>
          </v-col>
          <!-- IMAGEM  apos fechar-->
          <br />
          <v-text-field
            background-color="#2196f3"
            filled
            dark
            disabled
            label="Protocolo"
            v-model="demanda.protocolo"
          />
          <v-text-field
            background-color="#2196f3"
            filled
            dark
            disabled
            label="Modalidade"
            v-model="demanda.modalidade"
          />
          <v-text-field
            background-color="#2196f3"
            filled
            dark
            disabled
            label="Assunto"
            v-model="demanda.assunto"
          />

          <v-textarea
            background-color="#2196f3"
            color="white !important"
            no-resize
            type="info"
            dark
            rows="3"
            filled
            disabled
            label="Descrição"
            required
            v-model="demanda.descricao"
          />

          <v-divider></v-divider>
        </div>
        <!-- formulario -->
      </v-stepper-content>
      <!-- Visualização -->
    </v-stepper>

    <!-- DIALOG e Lista de Solicitações FIM-->
  </v-layout>
</template>   

<script>
// import { storage } from "@/main";

import { storage } from "@/main";
import firebase from "firebase";
import moment from "moment";

export default {
  name: "GoogleMap",

  mounted() {
    this.chamaOverlay(2000);
  },

  watch: {
    //aqui fica escutando evento dos objetos :p

    user() {
      this.getSolicitacoes();
    },
  },

  data() {
    return {
      texto: "",
      carregando: false,
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      places: [],
      currentPlace: null,
      EnderecoPersonalizado: "",
      user: null,

      modalidades: [
        { nome: "ACADEMIA", img: "@/Arquivos/icons/ACADEMIA.png" },
        { nome: "CASCALHO", img: "@/Arquivos/icons/CASCALHO.png" },
        { nome: "EDUCACAO", img: "@/Arquivos/icons/EDUCACAO.png" },
        { nome: "ILUMINACAO", img: "@/Arquivos/icons/ILUMINACAO.png" },
        { nome: "LIMPEZA", img: "@/Arquivos/icons/LIMPEZA.png" },
        { nome: "ARVORE", img: "@/Arquivos/icons/ARVORE.png" },
        { nome: "SAUDE", img: "@/Arquivos/icons/SAUDE.png" },
        { nome: "SEGURANCA", img: "@/Arquivos/icons/SEGURANCA.png" },
        { nome: "BURACO", img: "@/Arquivos/icons/BURACO.png" },
        { nome: "TRANSITO", img: "@/Arquivos/icons/TRANSITO.png" },
        { nome: "TRANSPORTE", img: "@/Arquivos/icons/TRANSPORTE.png" },
        { nome: "OUTROS", img: "@/Arquivos/icons/OUTROS.png" },
      ],

      objSlide: 1,
      objSlide2: 1,

      overlay: false,

      valid: false,
      btnDisabled: false,
      descricaoRules: [
        (v) => !!v || "Obrigatória",
        // (v) => v.length <= 10 || "Name must be less than 10 characters",
      ],
      assuntoRules: [
        (v) => !!v || "Obrigatória",
        (v) => v.length <= 25 || "Assunto com no maximo 25 Caractéres",
      ],
      enderecoRules: [(v) => !!v || "Obrigatório"],
      bairroRules: [(v) => !!v || "Obrigatório"],
      modalidadeRules: [(v) => !!v || "Obrigatório"],

      alert: false,
      msgAlert: "",
      arquivo: null,
      solicitacoes: [],
      demanda: {
        id: "",
        tipo: "",
        assunto: "",
        modalidade: "",
        endereco: "",
        bairro: "",
        cidade: "",
        longitude: "",
        latitude: "",
        origem: "",
        descricao: "",
        andamento: [],
        img: "",
        status: "",
        usuarioIncAlt: "",
        data: "",
        solucaoDemanda: "",
        protocolo: "",
      },
      mensagem: {
        titulo: "",
        descricao: "",
        dataEnvio: null,
        remetente: "",
        color: "",
      },
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      }
    });

    this.geolocate();
  },
  methods: {
    async chamaOverlay(val) {
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      }, val);
    },

    redirecionarPagina(pagina) {
      this.$router.push("" + pagina);
    },

    async validaSalvarEditar(demandaID) {
      this.desabilitaBotaoPorSegundos();

      await this.$refs.form.validate();

      if (this.valid) {
        if (this.EnderecoPersonalizado == "") {
          this.mensagemAlerta("Selecione um Local");
          return;
        }
        this.save(demandaID);
      }
    },
    async save(demandaID) {
      if (!demandaID) {
        this.salvarDemanda();
        this.objSlide = 1;

        console.log("terminou de vez");
      } else {
        this.atualizarDemanda(demandaID);
      }
    },

    async obterNumeroProtocolo() {
      var geralDemanda = firebase.firestore().collection("demanda");

      geralDemanda.onSnapshot((snap) => {
        this.demanda.protocolo = snap.docs.length + 1000;
      });
    },
    async salvarDemanda() {
      let aux = "";
      let novaUrl = "";
      this.overlay = true;

      this.mensagem = {
        titulo: "Inicio",
        descricao:
          "Olá, Recebemos sua indicação. Assim que possível retornaremos com novidades",
        dataEnvio: new Date(),
        remetente: "Equipe João Cesar Mattogrosso",
        color: "blue",
      };

      this.demanda.andamento.push(this.mensagem);

      await this.obterNumeroProtocolo();

      await firebase
        .firestore()
        .collection("demanda")
        .add({
          id: "",
          tipo: "INDICACAO",
          assunto: this.demanda.assunto,
          modalidade: this.demanda.modalidade,
          endereco: this.demanda.endereco,
          bairro: this.demanda.bairro,
          cidade: this.demanda.cidade,
          longitude: this.demanda.longitude,
          latitude: this.demanda.latitude,
          origem: "MOBILE",
          descricao: this.demanda.descricao,
          data: new Date(),
          img: require("@/Arquivos/Aguarde.gif"),
          status: "ABERTO",
          andamento: this.demanda.andamento,
          usuarioIncAlt: firebase.auth().currentUser.email,
          solucaoDemanda: this.demanda.solucaoDemanda,
        })
        .then(function (docRef) {
          aux = docRef.id;
        });

      if (this.arquivo) {
        //salva IMG STORAGE

        const imageRef = storage.ref("demanda").child(aux);

        await imageRef.put(this.demanda.img).then(() => {
          return imageRef.getDownloadURL().then((url) => {
            var partes = url.split(aux);
            novaUrl = partes[0] + aux + "_800x800" + partes[1];
          });
        });
        this.overlay = false;

        var novoProtocolo = this.demanda.protocolo;
        setTimeout(function () {
          firebase.firestore().collection("demanda").doc(aux).update({
            protocolo: novoProtocolo,
            img: novaUrl,
            id: aux,
          });
        }, 5000);
      } else {
        this.overlay = false;

        firebase
          .firestore()
          .collection("demanda")
          .doc(aux)
          .update({
            protocolo: this.demanda.protocolo,
            img: require("@/Arquivos/solicitacoes.png"),
            id: aux,
          });
      }
    },
    async atualizarDemanda(demandaID) {
      if (this.arquivo == this.demanda.img) {
        firebase.firestore().collection("demanda").doc(demandaID).update({
          tipo: "INDICACAO",
          assunto: this.demanda.assunto,
          modalidade: this.demanda.modalidade,
          endereco: this.demanda.endereco,
          bairro: this.demanda.bairro,
          cidade: this.demanda.cidade,
          longitude: this.demanda.longitude,
          latitude: this.demanda.latitude,
          origem: "MOBILE",
          descricao: this.demanda.descricao,
          data: new Date(),
          usuarioIncAlt: firebase.auth().currentUser.email,
          solucaoDemanda: this.demanda.solucaoDemanda,
          protocolo: this.demanda.protocolo,
        });
        this.dialog = false;
      } else {
        firebase
          .firestore()
          .collection("demanda")
          .doc(demandaID)
          .update({
            tipo: "INDICACAO",
            assunto: this.demanda.assunto,
            modalidade: this.demanda.modalidade,
            endereco: this.demanda.endereco,
            bairro: this.demanda.bairro,
            cidade: this.demanda.cidade,
            longitude: this.demanda.longitude,
            latitude: this.demanda.latitude,
            origem: "MOBILE",
            descricao: this.demanda.descricao,
            data: new Date(),
            andamento: this.demanda.andamento,
            img: require("@/Arquivos/Aguarde.gif"),
            usuarioIncAlt: firebase.auth().currentUser.email,
            solucaoDemanda: this.demanda.solucaoDemanda,
            protocolo: this.demanda.protocolo,
          });
        this.dialog = false;

        //incluindo nova img
        await storage
          .ref("demanda")
          .child(this.demanda.id)
          .put(this.demanda.img); // o storage deleta o antigo automaticamente

        var urlAntiga = await storage
          .ref("demanda")
          .child(this.demanda.id)
          .getDownloadURL();

        var partes = urlAntiga.split(demandaID);
        var provavelUrlNova = partes[0] + demandaID + "_800x800" + partes[1];

        setTimeout(function () {
          firebase.firestore().collection("demanda").doc(demandaID).update({
            img: provavelUrlNova,
          });
        }, 10000);
      }
    },

    async getSolicitacoes() {
      var geralDemanda = firebase
        .firestore()
        .collection("demanda")
        .where("usuarioIncAlt", "==", firebase.auth().currentUser.email)
        .orderBy("data", "desc");
      //.orderBy("status");
      //.where("status", "==", "ABERTO");

      //  console.log("esse :"+this.user.email)

      geralDemanda.onSnapshot((snap) => {
        this.solicitacoes = [];
        snap.forEach((doc) => {
          var demanda = doc.data();
          this.solicitacoes.push(demanda);
        });
      });
    },

    quandoSelecionarImagem() {
      let input = this.$refs.fileInput;
      let files = input.files;
      //valida tamanho img e formato
      var tamanho = files[0].size;
      var formato = files[0].type;

      if (tamanho > 20971520) {
        //20MB
        this.mensagemAlerta("Tamanho máximo permitido: 20Mb");
        return;
      }
      if (formato != "image/jpeg" && formato != "image/png") {
        this.mensagemAlerta("Formato (" + formato + ") não permitido");
        return;
      }
      //valida tamanho img e formato
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.arquivo = e.target.result;
          this.demanda.img = files[0];
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },

    abrirSelecaoImagem() {
      this.$refs.fileInput.click();
      //  this.arquivo = null;
    },

    async limpaCampos() {
      this.resetValidation();
      this.EnderecoPersonalizado = "";
      this.demanda = {
        id: "",
        tipo: "",
        assunto: "",
        modalidade: "",
        endereco: "",
        bairro: "",
        cidade: "",
        longitude: "",
        latitude: "",
        origem: "",
        descricao: "",
        andamento: [],
        img: "",
        status: "",
        usuarioIncAlt: "",
        data: "",
        solucaoDemanda: "",
        protocolo: "",
      };
      this.arquivo = null;

      this.fecharAlert();
      // this.resetValidation();
    },
    async resetValidation() {
      this.$refs.form.resetValidation();
    },

    async desabilitaBotaoPorSegundos() {
      this.btnDisabled = true;
      await setTimeout(() => {
        this.btnDisabled = false;
      }, 8000);
    },

    async abrirDialogCadastroDemanda() {
      this.zerarDemanda();
      this.EnderecoPersonalizado = "";
    },
    async zerarDemanda() {
      this.demanda = {
        id: "",
        tipo: "",
        assunto: "",
        modalidade: "",
        endereco: "",
        bairro: "",
        cidade: "",
        longitude: "",
        latitude: "",
        origem: "",
        descricao: "",
        img: "",
        status: "",
        usuarioIncAlt: "",
        andamento: [],
        data: "",
        solucaoDemanda: "",
        protocolo: "",
      };
    },
    async mensagemAlerta(msg) {
      this.fecharAlert();
      this.msgAlert = "\n" + msg + "\n";
      this.alert = true;
    },

    fecharAlert() {
      this.alert = false;
      this.msgAlert = "";
    },
    async deletarDemanda(demanda) {
      confirm("Realmente deseja remover ?") &&
        (await firebase
          .firestore()
          .collection("demanda")
          .doc(demanda.id)
          .update({
            status: "FECHADO",
          }));
    },

    async EditarDemanda(demanda) {
      this.demanda = demanda;
      this.arquivo = demanda.img;
      this.objSlide2 = 1;
      this.texto = ``;

      const marker = {
        lat: demanda.latitude,
        lng: demanda.longitude,
      };

      this.markers = [];
      this.markers.push({ position: marker });

      this.center = marker;

      this.EnderecoPersonalizado = demanda.endereco + " - " + demanda.bairro; // limpa dados da busca anterior

      // this.currentPlace = null;
    },

    // GOOGLE MAPS
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };

        this.preencheEnderecoCompleto();

        // limpa dados da busca anterior
        this.markers = [];
        this.markers.push({ position: marker });
        this.center = marker;
        // this.currentPlace = null;
      }
    },
    geolocate: function () {
      // marker: marcador/ places: lugares

      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        // alert('lat:'+position.coords.latitude + '  long:'+position.coords.longitude )
        // this.markers.push({ position: { lat: position.coords.latitude, lng: position.coords.longitude} }); //new
      });
    },
    preencheEnderecoCompleto() {
      var NumeroRua;
      var Rua = "";
      var Bairro = "";
      var Cidade = "";
      var Estado = "";

      var ListaEnderecoCompleto = this.currentPlace.address_components;

      ListaEnderecoCompleto.forEach((element) => {
        switch (element.types[0]) {
          case "street_number":
            NumeroRua = element.short_name;
            break;
          case "route":
            Rua = element.short_name;
            break;
          case "sublocality_level_1":
            Bairro = element.short_name;
            break;
          case "administrative_area_level_2":
            Cidade = element.short_name;
            break;
          case "administrative_area_level_1":
            Estado = element.short_name;
            break;

          default:
            break;
        }
      });

      var local = this.currentPlace.address_components[0].types[0]; // aqui que verei oque ele colocoue restringe o nuvel apenas até bairro
      if (
        local != "street_number" &&
        local != "route" &&
        local != "sublocality_level_1"
      ) {
        this.EnderecoPersonalizado = "";
        this.mensagemAlerta("Apenas Ruas e Bairros são permitidos");
        return;
      }

      if (Estado != "MS") {
        this.mensagemAlerta(
          "Apenas endereços de Mato Grosso do Sul são permitidos"
        );
        return;
      }

      this.demanda.bairro = Bairro;
      this.demanda.cidade = Cidade;
      this.demanda.latitude = this.currentPlace.geometry.location.lat();
      this.demanda.longitude = this.currentPlace.geometry.location.lng();

      this.demanda.endereco = Rua + ",  " + (NumeroRua ? NumeroRua : "");
      this.EnderecoPersonalizado =
        this.demanda.endereco + " - " + Bairro + ", " + Cidade + " - " + Estado;
    },

    // GOOGLE MAPS

    salvarTextoMensagem() {
      this.carregando = true;

      this.mensagem = {
        titulo: firebase.auth().currentUser.displayName,
        descricao: this.texto,
        dataEnvio: new Date(),
        remetente: firebase.auth().currentUser.email,
        color: "red",
      };
      this.demanda.andamento.push(this.mensagem);
      this.texto = "Enviando...";

      setTimeout(() => {
        this.carregando = false;
        this.texto = ``;
      }, 2000);

      firebase.firestore().collection("demanda").doc(this.demanda.id).update({
        andamento: this.demanda.andamento,
      });
    },
    dataFormatada(data) {
      if (new Date(data).getTime() > 0) {
        // os que vem do banco
        return data.toLocaleString();
      } else {
        // os que vem na hora
        return moment.unix(data.seconds).format("DD/MM  HH:mm");
      }
      //moment.unix(data).format("DD/MM/YYYY")  hh:mm = 11:00 am / HH:mm 23:00
    },
  },
};
</script>

<style scoped>
/* ESTILO SÒ PARA ABRIR A IMAGEM POR ENQUANTO */

.base-image-input {
  /*  altera tamanho da foto */
  width: 100%;
  height: 220px;

  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.placeholder {
  background: #f0f0f0;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: Helvetica;
}
.placeholder:hover {
  background: #e0e0e0;
}
.file-input {
  display: none;
}

/* ESTILO SÒ PARA ABRIR A IMAGEM POR ENQUANTO */
</style>